import { render } from "./Shape.vue?vue&type=template&id=747d5155"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Shape.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "747d5155"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('747d5155', __exports__)) {
    api.reload('747d5155', __exports__)
  }
  
  module.hot.accept("./Shape.vue?vue&type=template&id=747d5155", () => {
    api.rerender('747d5155', render)
  })

}


export default __exports__